/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { OrgAdminGetUserDetailOptions, OrgAdminGetUserDetailResponses } from '../../models/OrgAdminGetUserDetail'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get user detail, including courses.
 * This endpoint is intended for org admins to view details of users in their org.
 * @summary Get User Detail
 * {@link /user/:user_id/detail}
 */
export function orgAdminGetUserDetail<ThrowOnError extends boolean = true>(options: Options<OrgAdminGetUserDetailOptions, ThrowOnError>): Promise<UnwrappedResult<OrgAdminGetUserDetailResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/user/{user_id}/detail', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<OrgAdminGetUserDetailResponses, ThrowOnError>>
}
